import { alpha } from "@mui/material/styles";
// project imports
import { extendPaletteWithChannels } from "utils/colorUtils";

// ----------------------------------------------------------------------

// NEW COLOR SETUP
const PRIMARY = {
    lighter: "#D6E4FF",
    light: "#84A9FF",
    main: "#30c0f2",
    dark: "#284253",
    darker: "#091A7A",
};

const SECONDARY = {
    lighter: "#D6E4FF",
    light: "#84A9FF",
    main: "#30c0f2",
    dark: "#284253",
    darker: "#091A7A",
};

const INFO = {
    lighter: "#D0F2FF",
    light: "#74CAFF",
    main: "#30c0f2",
    dark: "#0C53B7",
    darker: "#04297A",
};

const SUCCESS = {
    lighter: "#E9FCD4",
    light: "#AAF27F",
    main: "#54D62C",
    dark: "#229A16",
    darker: "#08660D",
};

const WARNING = {
    lighter: "#FFF7CD",
    light: "#FFE16A",
    main: "#FFC107",
    dark: "#B78103",
    darker: "#7A4F01",
};

const ERROR = {
    lighter: "#FFE7D9",
    light: "#FFA48D",
    main: "#FF4842",
    dark: "#B72136",
    darker: "#7A0C2E",
};

const GREY = {
    0: "#FFFFFF",
    50: "#fafafa", // Added for light mode compatibility
    100: "#F9FAFB",
    200: "#F4F6F8",
    300: "#DFE3E8",
    400: "#C4CDD5",
    500: "#919EAB",
    600: "#637381",
    700: "#454F5B",
    800: "#212B36",
    900: "#161C24",
};

// ==============================|| BUILD THEME PALETTE ||============================== //

function buildThemePalette(mode) {
    const isLight = mode === "light";

    return {
        mode,
        primary: {
            ...PRIMARY,
            100: PRIMARY.lighter,
            200: PRIMARY.light,
            400: PRIMARY.main,
            700: PRIMARY.dark,
            900: PRIMARY.darker,
            contrastText: "#FFFFFF",
        },
        secondary: {
            ...SECONDARY,
            600: SECONDARY.dark,
            800: SECONDARY.darker,
            A100: GREY[0],
            A200: SECONDARY.main,
            A300: SECONDARY.dark,
            contrastText: "#FFFFFF",
        },
        error: {
            ...ERROR,
            contrastText: "#FFFFFF",
        },
        warning: {
            ...WARNING,
            contrastText: GREY[800],
        },
        info: {
            ...INFO,
            contrastText: "#FFFFFF",
        },
        success: {
            ...SUCCESS,
            contrastText: "#FFFFFF",
        },
        grey: GREY,
        text: {
            primary: isLight ? GREY[800] : "#FFFFFF",
            secondary: isLight ? GREY[600] : GREY[500],
            disabled: isLight ? GREY[500] : GREY[600],
        },
        background: {
            paper: isLight ? "#FFFFFF" : GREY[800],
            default: isLight ? "#FFFFFF" : GREY[900],
            neutral: isLight ? GREY[200] : alpha(GREY[500], 0.16),
        },
        custom: {
            sidebar: {
                background: isLight ? "#FFFFFF" : "#0A1120",
                textColor: isLight ? GREY[800] : "#FFFFFF",
            },
            topbar: {
                background: isLight ? "#FFFFFF" : GREY[800],
                textColor: isLight ? GREY[800] : "#FFFFFF",
            },
        }
    };
}

// ==============================|| DEFAULT THEME - PALETTE ||============================== //

export function buildPalette() {
    const commonColor = { common: { black: "#000", white: "#fff" } };

    const lightPaletteColor = buildThemePalette("light");
    const darkPaletteColor = buildThemePalette("dark");

    const extendedLight = extendPaletteWithChannels(lightPaletteColor);
    const extendedDark = extendPaletteWithChannels(darkPaletteColor);
    const extendedCommon = extendPaletteWithChannels(commonColor);

    return {
        light: {
            ...extendedCommon,
            ...extendedLight,
            action: {
                active: GREY[600],
                hover: alpha(GREY[500], 0.08),
                selected: alpha(GREY[500], 0.16),
                disabled: alpha(GREY[500], 0.8),
                disabledBackground: alpha(GREY[500], 0.24),
                focus: alpha(GREY[500], 0.24),
            },
            divider: alpha(GREY[500], 0.24),
        },
        dark: {
            ...extendedCommon,
            ...extendedDark,
            action: {
                active: GREY[500],
                hover: alpha(GREY[500], 0.08),
                selected: alpha(GREY[500], 0.16),
                disabled: alpha(GREY[500], 0.8),
                disabledBackground: alpha(GREY[500], 0.24),
                focus: alpha(GREY[500], 0.24),
            },
            divider: alpha(GREY[500], 0.24),
        },
    };
}